// extracted by mini-css-extract-plugin
export default {"container":"pxGbUg9a","modal":"FQU0eImz","ant-modal-body":"uVoYeVTu"};